"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responsiveAxis = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _text = require("@visx/text");

var _axisLabels = require("./axisLabels.enum");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var responsiveAxis = function responsiveAxis(tick, selector, theme, axis, width, maxCharLength, textWidth) {
  var isRotate = selector.clientWidth <= width;
  var rotate = isRotate ? -45 : 0;
  var verticalAnchor = 'middle';
  var topYPadding;
  var topXPadding;
  var textAnchor;

  switch (axis) {
    case _axisLabels.axisLabels.yLeft:
      topYPadding = tick.textY;
      topXPadding = tick.textX;
      textAnchor = 'end';
      break;

    case _axisLabels.axisLabels.xBottom:
      topYPadding = isRotate ? 10 + tick.textY : 20;
      topXPadding = tick.textX;
      textAnchor = isRotate ? 'end' : tick.textAnchor;
      break;

    default:
      textAnchor = tick.textAnchor;
      topYPadding = 0;
      topXPadding = 0;
      break;
  }

  return (0, _jsxRuntime.jsx)(_text.Text, {
    x: tick.x + topXPadding,
    y: tick.y + topYPadding,
    angle: rotate,
    width: textWidth,
    verticalAnchor: verticalAnchor,
    textAnchor: textAnchor,
    dominantBaseline: "start",
    alignmentBaseline: tick.textBaseline,
    style: _objectSpread({}, theme.axis.ticks.text),
    children: maxCharLength && tick.value.length > maxCharLength ? tick.value.slice(0, maxCharLength) + '...' : tick.value
  });
};

exports.responsiveAxis = responsiveAxis;